<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="cpytxt"><a id="page_iv"></a><span class="smallcaps">LAST DOG ON THE HILL</span>. Copyright © 2010 by Steve Duno. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="cpytxt1"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="cpytxt1">Design by Kathryn Parise</p>
<p class="cpytxt1"><span class="smallcaps">LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA</span></p>
<p class="cpytxt2">Duno, Steve.</p>
<p class="cpytxt3"> Last dog on the hill : the extraordinary life of Lou / Steve Duno.—1st ed.</p>
<p class="cpytxt3">      p. cm.</p>
<p class="cpytxt3"> ISBN 978-0-312-60049-5</p>
<p class="cpytxt3">1. Dogs—Anecdotes. 2. Dog owners—Anecdotes. 3. Human-animal<br/>relationships—Anecdotes. 4. Dogs—Behavior. I. Title.</p>
<p class="cpytxt3"> SF426.2.D865 2010</p>
<p class="cpytxt3"> 636.7092'9—dc22</p>
<p class="cpytxt4">2009047031</p>
<p class="cpytxt1">First Edition: June 2010</p>
<p class="cpytxt1">10  9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?c5878ea6